import moment from "moment";
import { LoadState } from "../../constants/enums";

import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { IServiceItem } from "../service";

export interface ILeadsState {
  list: {
    list: ILead[];
    totalRecords: number;
    loading: LoadState;
    error: string | null;
  };
  lead: {
    data: ILead;
    loading: LoadState;
    error: string | null;
  };
  roughEstimate: {
    data: IRoughEstimate[];
    loading: LoadState;
    error: string | null;
  };

  generalHistory: {
    list: IGeneralHistory[];
    loading: LoadState;
  };
  recordCounts: {
    list: ILeadStatusCount[];
    loading: LoadState;
  };
  whatsappStatusUnrepliedCounts: {
    list: IWhatsAppStatusUnrepliedCount[];
    loading: LoadState;
  };
  driveStatusList: {
    list: any[];
    loading: LoadState;
  };
  driveStatusCategoryList: {
    list: any[];
    loading: LoadState;
  };
}

export interface IWhatsAppStatusUnrepliedCount {
  [key: string]: number;
}
export interface ILead {
  leads_uuid: string | null;
  country_code: string;
  lead_code: string;
  date_of_visit: string;
  function_date: string | null;
  function_month: string | null;
  // function_year: string | null;
  name_of_guest: string;
  contact_number_one: string;
  email: string;
  event_type: string;
  event_uuid: string;
  number_of_guests: number | null;
  handled_by_employee: string;
  // alt_function_month: string;

  event_time: string;
  event_time_uuid: string;
  preferred_venue: string;
  preferred_venue_uuid: string;
  number_of_rooms: number | null;
  remarks: string;
  event_name: string;
  event_timing_uuid: string;
  whatsapp_status: string;
  is_replied: number | null;
  company_outlet_uuid: string;
  company_outlet_name: string;
  booking_date: string | null;
  is_payment_transaction_exist: number;
  grand_total: string | null;
  is_archived: number;
  payment_mode: "BILL_TO_COMPANY" | "DIRECT" | null;
  cancellation_dead_reason: string | null;
  other_event_name: string | null;

  // venue_name: string;

  handled_by_employee_uuid: string;
  master_status_uuid: string | null;
  status: "ONGOING" | "CANCELLED" | "BOOKED" | "POSTPONED" | "DEAD";
  actual_status: string | null;
  derived_status: string | null;
  drive_status_uuid: string | null;
  followup_date: string | null;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
  to_number?: string;
  extras: IExtras | null;
  multiple_events: number;
  multiple_events_uuid: null;
  multiple_events_list: IMultipleEvent[];
  description: string | null;
  lead_source_uuid: string | null;
  source: string | null;

  additional_contact_number: IAdditionalContactNumber[];
}

export interface IAdditionalContactNumber {
  contact_number: string;
  country_code: string;
}

// Multiple events data structure
export interface IMultipleEvent {
  leads_uuid: string | null;
  event_type: string;
  event_uuid: string;
  event_time: string;
  event_time_uuid: string;
  preferred_venue: string;
  preferred_venue_uuid: string;
  // Event-specific fields (independent per row)
  booking_date: string | null;
  function_month?: string | null;
  function_date?: string | null;
  followup_date?: string | null;
  status: string;
  derived_status: string;
  drive_status_uuid: string;
  service?: IServiceItem[] | null;
  number_of_rooms: number | null;
  number_of_guests: number | null;

  // Conditional fields
  cancellation_dead_reason?: string | null;
  payment_mode?: "BILL_TO_COMPANY" | "DIRECT" | null;
  other_event_name?: string | null;
}

// Dynamic form fields data structure
// Key: field_uuid (form_labels_uuid)
// Value: Object with field_name and value
export interface IExtras {
  [field_uuid: string]: {
    field_name: string;
    value: string | number | boolean | string[] | null | undefined;
  };
}
export interface ItemCharge {
  name: string;
  count: number;
  total: number;
  amount: number;
  description: string | null;
}

export interface IRoughEstimate {
  rough_estimate_unique_id: number | null;
  rough_estimate_uuid: string | null;
  leads_uuid: string | null;
  booking_date: string | null;
  function_date: string | null;
  contact_number: string | null;
  venue_name: string | null;
  guest_count: number;
  gst_pan_number: string | null;
  items_charges: ItemCharge[];
  sub_total: string;
  tax_amount: string;
  tax_percentage: number | null;
  extras_amount: string;
  discount: string;
  discount_mode: "percentage" | "amount";
  advance_amount: string | null;
  grand_total: string;
  attachments: IFileUpload[] | null;
  status: "ACTIVE" | "ONGOING" | "CANCELLED" | "BOOKED" | "POSTPONED";
  company_outlet_uuid: string | null;
  company_outlet_name: string | null;
  company_outlet_branch_uuid: string | null;
  created_by_uuid: string | null;
  created_by_name: string | null;
  modified_by_uuid: string | null;
  modified_by_name: string | null;
  create_ts: string | null;
  insert_ts: string | null;
  payment_status: "UNPAID" | "PARTIALLY_PAID" | "PAID";
  is_payment_transaction_exist: number;
  total_amount_paid: number;
  remaining_balance: number;
}

export interface ILeadStatusCount {
  [key: string]: number;
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}

export interface ILeadSource {
  lead_source_uuid: string | null;
  source_name: string | null;
  source_name_link: string | null;
  company_outlet_uuid: string | null;
  status: "ACTIVE" | "INACTIVE";
}

export const initialLeadSource: ILeadSource = {
  lead_source_uuid: null,
  source_name: null,
  source_name_link: null,
  company_outlet_uuid: null,
  status: "ACTIVE",
};

export const initialMultipleEvent: IMultipleEvent = {
  leads_uuid: null,
  event_type: "",
  event_uuid: "",
  event_time: "",
  event_time_uuid: "",
  preferred_venue: "",
  preferred_venue_uuid: "",
  booking_date: null,
  status: "ONGOING",
  derived_status: "",
  drive_status_uuid: "",
  number_of_rooms: null,
  number_of_guests: null,
};

export const initialLead: ILead = {
  leads_uuid: "",
  country_code: "+91",
  lead_code: "",
  date_of_visit: moment().format(),
  function_date: null,
  email: "",
  function_month: null,
  name_of_guest: "",
  contact_number_one: "",
  event_type: "",
  event_uuid: "",
  // function_year: null,
  booking_date: null,
  number_of_guests: null,
  handled_by_employee: "",
  // alt_function_month: "",
  event_time: "",
  event_time_uuid: "",
  preferred_venue: "",
  preferred_venue_uuid: "",
  number_of_rooms: null,
  remarks: "",
  status: "ONGOING",
  followup_date: "",
  event_name: "",
  event_timing_uuid: "",
  whatsapp_status: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
  handled_by_employee_uuid: "",

  is_replied: null,
  is_payment_transaction_exist: 0,
  grand_total: null,
  is_archived: 0,
  payment_mode: null,
  cancellation_dead_reason: null,
  master_status_uuid: null,
  other_event_name: null,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  drive_status_uuid: "",
  derived_status: "ONGOING",

  actual_status: null,
  extras: null,
  multiple_events: 0,
  multiple_events_uuid: null,
  multiple_events_list: [],
  description: null,
  lead_source_uuid: null,
  source: null,

  additional_contact_number: [],
};

export const initialRoughEstimate: IRoughEstimate = {
  rough_estimate_unique_id: null,
  rough_estimate_uuid: null,
  leads_uuid: null,
  booking_date: null,
  function_date: null,
  contact_number: null,
  venue_name: null,
  guest_count: 0,
  gst_pan_number: null,
  items_charges: [],
  sub_total: "0.00",
  tax_amount: "0.00",
  tax_percentage: null,
  extras_amount: "0.00",
  discount: "0.00",
  discount_mode: "percentage",
  advance_amount: null,
  grand_total: "0.00",
  attachments: null,
  status: "ONGOING",
  company_outlet_uuid: null,
  company_outlet_name: null,
  company_outlet_branch_uuid: null,
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
  payment_status: "UNPAID",
  is_payment_transaction_exist: 0,
  total_amount_paid: 0,
  remaining_balance: 0,
};

export const initialLeadState: ILeadsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.Loaded,
    error: null,
  },
  lead: {
    data: initialLead,
    loading: LoadState.NotLoaded,
    error: null,
  },
  roughEstimate: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },

  generalHistory: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  recordCounts: {
    list: [],

    loading: LoadState.NotLoaded,
  },
  whatsappStatusUnrepliedCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  driveStatusList: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  driveStatusCategoryList: {
    list: [],
    loading: LoadState.NotLoaded,
  },
};
